import React from "react";
import { BrowserRouter } from "react-router-dom";

import MainPage from "./pages/main";
import Layout from "./layouts";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Layout variant="main">
          <MainPage />
        </Layout>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
